module.exports = __webpack_public_path__ + "img/graph.c7ade2ac.png";